import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { ToastContext } from "../../../context/ToastContext";
import { useEmployeFilter } from "../../../context/EmployeFilterContext";
import { useCalender } from "../Dashboard/useCalender";
import { useLocation } from "react-router-dom";


const statuses = [
    { key: "New", badge: "rgba(13, 110, 253, 0.2)", icon: "fa-solid fa-inbox", iconColor: "#0d6efd" },
    { key: "In Progress", badge: "rgba(255, 146, 43, 0.2)", icon: "fa-solid fa-arrow-trend-up", iconColor: "#ff922b" },
    { key: "ReOpen", badge: "rgba(228, 231, 5, 0.2)", icon: "fa-solid fa-repeat", iconColor: "#d9dd01" },
    { key: "Forwarded", badge: "rgba(6, 182, 212, 0.2)", icon: "fa-solid fa-forward", iconColor: "#06b6d4" },
    { key: "Close", badge: "rgba(22, 163, 74, 0.2)", icon: "fa-solid fa-circle-check", iconColor: "#16a34a" },
    { key: "Rejected", badge: "rgba(239, 68, 68, 0.2)", icon: "fa-solid fa-circle-xmark", iconColor: "#ef4444" }
];

export const useUniversalHelpdesk = () => {
    const { showTimesheet, setShowTimesheet } = useCalender()
    const { showInfo, showError } = useContext(ToastContext)
    const { ticketComment } = useEmployeFilter();
    const [data, setData] = useState({
        tickets: []
    });
    const tagRef = useRef(null)
    const [filters, setFilters] = useState({ type: "", subtype: "", priority: { priority_name: "All" }, status: "", date: "", location: "" });
    const [editData, setEditData] = useState({})
    const [showPopup, setShowPopup] = useState({
        show: false,
        type: "create"
    });
    const [options, setOptions] = useState({})
    const [pagination, setPagination] = useState({ displayPageOutOfTotal: "", currentPage: 0, totalRecords: 0, totalPages: 0, show: false })
    const [loader, setLoader] = useState(false);
    const [statusCount, setStatusCount] = useState([]);
    const [dynamicField, setDynamicField] = useState([])
    const [historyPopup, setHistoryPopup] = useState({
        show: false,
        data: []
    });
    const [selectedData, setSelectedData] = useState({
        show: false,
        data: []
    });
    const [commentPopup, setCommentPopup] = useState({
        show: false,
        comments: [],
        inputs: "",
    });
    const location = useLocation().state;
    const [tab, setTab] = useState("");
    const [chart, setChart] = useState({visible: false})
    const chatRef = useRef(null);
    const columnDefs = [
        {
            headerName: 'Action',
            field: 'id',
            width: 100,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className="pt-2" style={{ height: "100%" }}>
                        <div className="d-flex justify-content-center align-items-center gap-2" >
                            <div className="inventory-icon border-dark border c-pointer hover:bg-dark d-flex justify-content-center align-items-center rounded" style={{ height: "20px", width: "20px", padding: "0.7rem" }} onClick={() => {
                                setShowPopup({
                                    show: true,
                                    type: "create"
                                }); setEditData(params?.data)
                            }} title="Edit">
                                <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                            </div>
                            <div className="inventory-icon border-primary border c-pointer hover:bg-dark d-flex justify-content-center align-items-center rounded text-primary" style={{ height: "20px", width: "20px", padding: "0.7rem" }} title="History" onClick={() => { if (params?.data?.history_counts > 0) { getTicketHistory(params?.data?.ticket_id); setHistoryPopup({ show: true, data: [] }) } }}>
                                {params?.data?.history_counts}
                            </div>
                            <div className="inventory-icon border-warning border c-pointer hover:bg-dark d-flex position-relative justify-content-center align-items-center rounded text-warning" style={{ height: "20px", width: "20px", padding: "0.7rem" }} title="History" onClick={() => {
                                setCommentPopup({ show: true, data: params?.data, comments: params?.data?.comments, id: params?.data?.ticket_id, inputs: '' })
                                if (params?.data?.comment_counts > 0) {
                                    const readComments = _.filter(params?.data?.comments, comment => comment.is_read === null || comment.is_read === false);
                                    updateTicketCommentsRead(_.uniq(_.pluck(readComments, 'ticket_comment_id')))
                                }
                            }}>
                                <FontAwesomeIcon icon="fa-solid fa-comments" />
                                {
                                    params?.data?.comment_counts > 0 && <div className="badge-count ">
                                        <span className="count"> {params?.data?.comment_counts}</span>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>

                )
            }
        },
        { headerName: 'Employee ID', field: 'employee_id', sortable: true, width: 100 },
        { headerName: 'Employee Name', field: 'user_display_name', sortable: true, width: 140 },
        { headerName: 'Request Type', field: 'request_type_name', sortable: true, width: 150 },
        {
            headerName: 'Subtype',
            width: 150,
            field: 'request_sub_type_name',
            cellRenderer: (params) => {
                return <>
                    <p title={params?.value}>{params?.value}</p>
                </>
            }
        },
        {
            headerName: 'Subject',
            field: 'ticket_subject',
            width: 200,
            cellRenderer: (params) => {
                return <>
                    <p title={params?.value}>{params?.value}</p>
                </>
            }
        },
        { headerName: 'Priority', field: 'priority_name', sortable: true, width: 80, cellStyle: { textAlign: "center" } },
        { headerName: 'Status', field: 'status_name', sortable: true, width: 80, cellStyle: { textAlign: "center" } },
        {
            headerName: 'Closed By', field: 'closed_by_user_name', sortable: true, width: 120, cellStyle: { textAlign: "center" },
            hide: _.findWhere(options?.requestStatus, { status_id: filters?.status })?.status_name?.toLowerCase() !== "close",
            cellRenderer: (params) => {
                return <div title={params?.value} className="text-truncate">{params?.value}</div>;
            },
        },
        {
            headerName: 'Created At', field: 'created_datetime', sortable: true, width: 140,
            cellRenderer: (params) => {
                return <>
                    <p>{params?.value && dateConvert(params?.value, "date-time-months")}</p>
                </>
            }
        },
        {
            headerName: 'Summary',
            field: 'ticket_summary',
            width: 230,
            cellRenderer: (params) => {
                return <>
                    <p title={params?.value}>{params?.value}</p>
                </>
            }
        },
        {
            headerName: 'Problem Solution',
            field: 'remarks',
            cellRenderer: (params) => {
                return <p title={params.value}>{params.value}</p>;
            },
            width: 250,
        },
        {
            headerName: 'Pending Since',
            field: 'request_pending',
            width: 120,
            cellStyle: { textAlign: "center" }
        },
        {
            headerName: 'Attachments',
            field: 'attachments',
            cellRenderer: (params) => {
                return <div className="text-center text-primary text-decoration-underline c-pointer" onClick={() => setSelectedData({ show: true, data: params?.data?.media })}>
                    {params?.data?.media?.length} files
                </div>
            },
            sortable: false,
            filter: false,
            width: 100
        },
        {
            headerName: 'Log',
            field: 'log',
            width: 20,
            cellRenderer: () => {
                return (
                    <div className="text-center" style={{ color: 'black', cursor: 'pointer' }} >
                        <FontAwesomeIcon icon="fa-solid fa-clock" onClick={() => { setShowTimesheet(true); }} title="Log Timesheet" />
                    </div>
                );
            },
        },

    ]

    useEffect(() => {
        callautopopulate("ticket_request_type", "user_info", "ticket_sub_request_type", "ticket_request_priority", "ticket_request_status", "all_users", "ticket_request_type_columns", "projects", "parent_request_id", "locations").then((res) => {
            setOptions(({
                allType: res?.ticket_request_type,
                requestType: _.filter(res?.ticket_request_type, (item) => !item?.parent_request_type_id),
                allSubType: res?.ticket_sub_request_type,
                subRequestType: res?.ticket_sub_request_type,
                priorityOption: res?.ticket_request_priority,
                requestStatus: res?.ticket_request_status,
                users: _.uniq(res?.all_users, (item) => item.user_code)?.sort((a, b) => a?.user_display_name?.localeCompare(b?.user_display_name)),
                user: res?.user_info?.[0],
                requestTypeColumns: res?.ticket_request_type_columns,
                projectOpt: _.sortBy(res?.projects, "project_name"),
                locations: res?.locations?.sort((a, b) => a?.location?.localeCompare(b?.location)),
            }))

            const status = _.find(res?.ticket_request_status, (item) => item?.status_name?.toLowerCase() === "new");
            const userLocation = _.findWhere(res?.all_users, { user_code: res?.user_info?.[0]?.user_code })?.location_name;
            const loc = _.findWhere(_.filter(res?.locations, loc => loc?.location), { location: userLocation });
            setFilters(prev => ({ ...prev, status: status?.status_id, location: loc || null }));
        })
    }, []);

    useEffect(() => {
        if (location?.helpdesk === "chart") {
            setTab("chart")
        } else {
            setTab("");
        }
    }, [location])

    useEffect(() => {
        setCommentPopup((prev) => ({
            ...prev, inputs: '', comments: [...prev?.comments, {
                "ticket_id": ticketComment?.ticket_id,
                "commented_by": ticketComment?.from_user_code,
                "comments": ticketComment?.comment,
                "commented_date": ticketComment?.comment_sent_datetime,
                "image_url": ticketComment?.profile_image_url,
                "ticket_comment_id": ticketComment?.ticket_comment_id,
                "is_read": false,
            }]
        }))

        setData(prevData => ({
            ...prevData,
            tickets: prevData.tickets.map(ticket => {
                return ticket.ticket_id === ticketComment?.ticket_id
                    ? { ...ticket, comment_counts: ticket.comment_counts > 1 ? ticket.comment_counts + 1 : 1 }
                    : ticket
            })
        }));
    }, [ticketComment]);

    useEffect(() => {
        options?.requestStatus?.length > 0 && getRequestData()
    }, [options?.requestStatus, pagination?.currentPage, filters?.priority])

    const getRequestData = async (key, status_id) => {
        try {
            setLoader(true);
            setPagination((prev) => ({ ...prev, show: false }));
            const requestSubTypeIds = _.pluck(filters.subtype, "request_sub_type_id")?.toString() || "";

            const payload = {
                "request_type_ids": key === "type" ? "" : filters?.requestType?.request_type_id?.toString() || "",
                "request_sub_type_ids": requestSubTypeIds,
                "priority_ids": filters?.priority?.priority_id?.toString() || "",
                "status_ids": status_id ? status_id?.toString() : filters?.status?.toString() || "",
                "from_date": (filters?.date && filters?.date[0] !== undefined) ? dateHoverRange(filters?.date[0]) : '',
                "to_date": (filters?.date && filters?.date[1] !== undefined) ? dateHoverRange(filters?.date[1]) : '',
                "ticket_closed_by": _.pluck(filters?.closeBy, "user_code")?.toString(),
                page_number: pagination?.currentPage === 0 ? 0 : pagination?.currentPage - 1,
                "location": key === "location" ? "" : filters?.location?.location || ""
            };

            const res = await services.getInvokeRemote("POST", Urls("GETTICKETREQUESTLIST"), payload);
            if (!res?.body?.error_status) {
                setStatusCount(res?.body?.data?.ticket_status_counts);
                const full_ticket_obj = res?.body?.data?.ticket_request_details?.map(ticket => ({
                    ...ticket,
                    media: (res?.body?.data?.ticket_media_data?.filter(m => m.ticket_id === ticket.ticket_id) || []).map(item => ({
                        ticket_media_id: item.ticket_media_id,
                        file: item.ticket_unique_file_id,
                        base64: item.ticket_unique_file_id
                    })) || [],
                    comments: res?.body?.data?.ticket_comment_data?.filter(c => c.ticket_id === ticket.ticket_id) || [],
                    request_type_column_values: res?.body?.data?.ticket_request_type_column_value_data?.filter(c => c.ticket_id === ticket.ticket_id) || [],
                }));
                setPagination((prev) => ({
                    ...prev,
                    totalRecords: res?.body?.data?.paging_info?.[0]?.total_tickets,
                    displayPageOutOfTotal: res?.body?.data?.paging_info[0]?.current_records,
                    totalPages: res?.body?.data?.paging_info[0]?.paging,
                    show: true
                }));
                setFilters((prev) => ({ ...prev, isChange: false }));
                const prioritiesCount = res?.body?.data?.ticket_priority_count || [];
                const totalTickets = (prioritiesCount || [])
                    .reduce((sum, item) => sum + (item.ticket_count || 0), 0);
                setData({
                    tickets: full_ticket_obj,
                    priorityCount: [
                        { priority_name: "All", ticket_count: totalTickets },
                        ...prioritiesCount
                    ]
                });
            }
            setLoader(false);
        } catch (error) {
            setLoader(false);
            console.error("error::", error);
        }
    };

    const getExcelDownload = async () => {
        const tickets = data?.tickets;
        if (!tickets?.length) {
            showInfo("Info", "There is no data to download");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("universal_helpdesk");
        let headers = [
            { header: "Employee ID", key: "employee_id", width: 20 },
            { header: "Employee Name", key: "user_display_name", width: 25 },
            { header: "Location", key: "location", width: 25 },
            { header: "Request Type", key: "request_type_name", width: 25 },
            { header: "Subtype", key: "request_sub_type_name", width: 25 },
            { header: "Subject", key: "ticket_subject", width: 25 },
            { header: "Priority", key: "priority_name", width: 15 },
            { header: "Status", key: "status_name", width: 15 },
            { header: "Summary", key: "ticket_summary", width: 30 },
            { header: "Problem Solution", key: "remarks", width: 30 },
            { header: "Created At", key: "created_datetime", width: 25 },
            { header: "Pending Since", key: "request_pending", width: 20 },
            { header: "Attachments", key: "media", width: 30 }
        ];

        if (_.findWhere(options?.requestStatus, { status_id: filters?.status })?.status_name?.toLowerCase() === "close") {
            headers.splice(7, 0, { header: 'Closed By', key: 'closed_by_user_name', width: 20 });
        }

        worksheet.columns = headers;
        tickets.forEach(ticket => {
            worksheet.addRow({
                ...ticket,
                created_datetime: dateConvert(ticket.created_datetime, "date-time-months"),
                media: ticket.media?.map(val => val?.file).join(", ") || ""
            });
        });
        worksheet.getRow(1).font = { bold: true };
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        saveAs(blob, "universal_helpdesk.xlsx");
    };

    const getTicketHistory = async (id) => {
        try {
            const payload = {
                "ticket_id": id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETTICKETHISTORY"), payload);
            if (!res?.body?.error_status) {
                setHistoryPopup((prev) => ({ ...prev, data: res?.body?.data?.ticket_history_details || [] }))
            }
        } catch (error) {
            console.error("error::", error)
        }
    }

    useEffect(() => {
        if (commentPopup?.show) {
            const timer = setTimeout(() => {
                if (chatRef.current) {
                    chatRef.current.scrollTop = chatRef.current.scrollHeight;
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [commentPopup?.show, commentPopup?.comments]);


    const saveComment = async () => {
        try {
            if (!commentPopup?.inputs?.trim()) {
                return;
            }
            const combinedString = commentPopup?.data?.created_by?.toString() + ',' + commentPopup?.data?.mapping_user_codes;

            const uniqueArray = [...new Set(combinedString.split(',').map(item => item.trim()).filter(Boolean))];
            const payload = {
                "ticket_id": commentPopup?.id,
                "comments": commentPopup?.inputs,
                "profile_image_url": options?.user?.image_url,
                "requested_user_codes": uniqueArray?.toString()
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVETICKETCOMMENT"), payload);
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
            } else if (!res?.body?.error_status) {
                setCommentPopup((prev) => ({ ...prev, inputs: '' }))
            } else {
                showError("Error", res?.body?.message);
            }
        } catch (error) {
            console.error("error::", error)
        }
    }

    const updateTicketCommentsRead = async (id) => {
        try {
            const payload = {
                "ticket_comment_id": id?.toString() || "",
            }
            const res = await services.getInvokeRemote("POST", Urls("UPDATETICKETCOMMENTSREAD"), payload);
            if (res?.body.StatusCode === 400 || res?.body.StatusCode === 204 || res?.body.StatusCode === 202 || res?.body.StatusCode === 401 || res?.body.StatusCode === 500) {
                showError('Error', res?.body.errorMessage);
            } else {
                getRequestData()
            }
        } catch (error) {
            console.error("error::", error)
        }
    }
    const handleDropdownChange = (newValue, index) => {
        const updatedPath = [...dynamicField];
        updatedPath[index] = newValue ? [newValue] : [];
        if (!newValue) {
            for (let i = index + 1; i < updatedPath.length; i++) {
                updatedPath[i] = [];
            }
        }
        const allowedTypeIds = updatedPath.flatMap(level => level || []).map(item => item.request_type_id);
        for (let i = index + 1; i < updatedPath.length; i++) {
            if (updatedPath[i]) {
                updatedPath[i] = updatedPath[i].filter(selectedChild =>
                    allowedTypeIds.includes(selectedChild.parent_request_type_id)
                );
            }
        }
        const finalActiveTypeIds = updatedPath.flatMap(level => level || []).map(item => item.request_type_id);
        let fallbackRequestType = newValue;
        if (!newValue) {
            for (let i = index - 1; i >= 0; i--) {
                if (updatedPath[i] && updatedPath[i].length > 0) {
                    fallbackRequestType = updatedPath[i][0];
                    break;
                }
            }
        }

        setDynamicField(updatedPath);
        setFilters(prev => {
            const currentSelectedSubtypes = prev.subtype || [];
            const validSubtypes = currentSelectedSubtypes.filter(sub =>
                finalActiveTypeIds.includes(sub.request_type_id)
            );

            return {
                ...prev,
                requestType: fallbackRequestType || null,
                subtype: validSubtypes,
                isChange: true
            };
        });
    };

    useEffect(() => {
        const allSelectedParentIds = dynamicField
            .flatMap(level => level || [])
            .map(item => item.request_type_id);

        if (allSelectedParentIds.length > 0) {
            const matchedLeafSubtypes = _.filter(options?.subRequestType, (sub) =>
                allSelectedParentIds.includes(sub.request_type_id)
            );
            setOptions(prev => ({ ...prev, filtersubRequestType: matchedLeafSubtypes }));
        } else {
            setOptions(prev => ({ ...prev, filtersubRequestType: [] }));
        }
    }, [dynamicField, options?.subRequestType]);

    return useMemo(() => ({
        filters, setFilters, options, statuses, data, columnDefs, setShowPopup, showPopup, editData, setEditData, getRequestData, loader, selectedData, setSelectedData, tagRef, getExcelDownload, historyPopup, setHistoryPopup, commentPopup, setCommentPopup, saveComment, chatRef, pagination, setPagination, statusCount, updateTicketCommentsRead, showTimesheet, setShowTimesheet, dynamicField, handleDropdownChange, tab,chart, setChart
    }), [filters, setFilters, options, statuses, data, columnDefs, setShowPopup, showPopup, editData, setEditData, getRequestData, loader, selectedData, setSelectedData, tagRef, getExcelDownload, historyPopup, setHistoryPopup, commentPopup, setCommentPopup, saveComment, chatRef, pagination, setPagination, statusCount, updateTicketCommentsRead, showTimesheet, setShowTimesheet, dynamicField, handleDropdownChange, tab,chart, setChart])

}